export default {
  selectedAdminProfile: 'admin',
  AdminProfiles: [
    'admin', 'ventasHistorial', 'ventas', 'gestion'
  ],
  ConfigDB: {}
}
